// extracted by mini-css-extract-plugin
export default {"button":"button_button__v+QYK","linkStyle":"button_linkStyle__xCK3u"};